import React from 'react';
import { RecordLabelCell } from '../components/workflow/CoverageDisplay';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { submitKeysOf } from '../components/workflow/useWorkflowPerms';
import WorkflowListShell from '../components/workflow/WorkflowListShell';
import WorkflowStatusBadge from '../components/workflow/WorkflowStatusBadge';
import ReviewerLapsedNote from '../components/workflow/ReviewerLapsedNote';
import { formatDateShort } from '../utils/dateFormat';
import { natureLabel } from './qcAddendum';

// QC6 / QC7 Addendum — list page (docs/modules/workflow-qcad.md).
// Partner-reviewed: your own requests plus those on records covering
// engagements you lead.
const WorkflowQcad = () => {
  const { hasPermission } = useAuth();
  return (
    <WorkflowListShell
      title="QC6 / QC7 Addendum"
      subtitle="Information identified after a QC6 / QC7 was approved."
      newTo="/workflow/qcad/new"
      canCreate={submitKeysOf('qcad').some(hasPermission)}
      apiPath="/api/workflow/qcad"
      searchPlaceholder="Search request no, record or requester…"
      width="mid"
      rowTo={(r) => `/workflow/qcad/${r.id}`}
      columns={[
        {
          key: 'requestNo', label: 'Request', sortKey: 'requestNo', className: 'whitespace-nowrap',
          render: (r) => (
            <Link to={`/workflow/qcad/${r.id}`} onClick={(e) => e.stopPropagation()} className="text-blue-600 hover:text-blue-800 font-medium">
              {r.requestNo}
            </Link>
          ),
        },
        { key: 'recordLabel', label: 'QC Record', sortKey: 'recordLabel', render: (r) => <RecordLabelCell label={r.recordLabel} items={r.recordEngagements} /> },
        {
          key: 'nature', label: 'Nature',
          render: (r) => (
            <span className="text-slate-600">
              {(r.nature || []).map(natureLabel).join(', ') || '—'}
              {r.riskChanged && <span className="ml-1.5 inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-medium bg-amber-50 text-amber-700">{r.riskFrom} → {r.riskTo}</span>}
            </span>
          ),
        },
        { key: 'status', label: 'Status', sortKey: 'status', render: (r) => (<><WorkflowStatusBadge status={r.status} /><ReviewerLapsedNote when={r.reviewerLapsed} /></>) },
        { key: 'requester', label: 'Requested By', className: 'text-slate-600', render: (r) => r.requesterEmail },
        { key: 'createdAt', label: 'Submitted', sortKey: 'createdAt', className: 'text-slate-600 whitespace-nowrap', render: (r) => formatDateShort(r.createdAt) },
      ]}
    />
  );
};

export default WorkflowQcad;
